"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashFaceAtUrl = exports.searchFaceInCollection = exports.searchImageInCollection = exports.deleteFace = void 0;
var client_rekognition_1 = require("@aws-sdk/client-rekognition");
var client_s3_1 = require("@aws-sdk/client-s3");
var neverthrow_1 = require("neverthrow");
var stream_1 = require("./stream");
var node_fetch_1 = __importDefault(require("node-fetch"));
var decode_1 = require("./decode");
var s3_1 = require("@aidkitorg/gateways/dist/aws/s3");
function deleteFace(faceId, CollectionId, deploymentKey) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var client, command, result, error_1;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    client = new client_rekognition_1.RekognitionClient({});
                    command = new client_rekognition_1.DeleteFacesCommand({ CollectionId: CollectionId, FaceIds: [faceId] });
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, client.send(command)];
                case 2:
                    result = _d.sent();
                    if ((_c = (_b = (_a = result.UnsuccessfulFaceDeletions) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.Reasons) === null || _c === void 0 ? void 0 : _c.includes('FACE_NOT_FOUND')) {
                        console.warn('Tried to delete a face that does not exist', { extra: { faceId: faceId, CollectionId: CollectionId } });
                    }
                    return [2 /*return*/, result];
                case 3:
                    error_1 = _d.sent();
                    if (error_1 instanceof client_rekognition_1.ResourceNotFoundException) {
                        console.error('Error trying to delete a face', { extra: { faceId: faceId, CollectionId: CollectionId } }, error_1);
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.deleteFace = deleteFace;
function addFacesToCollection(_a) {
    var Bucket = _a.Bucket, Name = _a.Name, ExternalImageId = _a.ExternalImageId, CollectionId = _a.CollectionId, config = _a.config;
    return __awaiter(this, void 0, void 0, function () {
        var client, ignoreFaces, MaxFaces, results, indexFaces, s3, listObjectsResponse;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    client = new client_rekognition_1.RekognitionClient({});
                    ignoreFaces = (config.ignore_faces || '').split(',');
                    MaxFaces = ignoreFaces.filter(function (v) { return v; }).length + 1;
                    results = {
                        indexed: [],
                        unindexed_reasons: []
                    };
                    indexFaces = function (command) { return __awaiter(_this, void 0, void 0, function () {
                        var response, err_1, _a, _b, face, e_1;
                        var _c, e_2, _d;
                        var _e, _f;
                        return __generator(this, function (_g) {
                            switch (_g.label) {
                                case 0:
                                    _g.trys.push([0, 9, , 10]);
                                    response = void 0;
                                    _g.label = 1;
                                case 1:
                                    _g.trys.push([1, 3, , 8]);
                                    return [4 /*yield*/, client.send(command)];
                                case 2:
                                    response = _g.sent();
                                    return [3 /*break*/, 8];
                                case 3:
                                    err_1 = _g.sent();
                                    if (!((_e = err_1.message) === null || _e === void 0 ? void 0 : _e.includes('The collection id'))) return [3 /*break*/, 6];
                                    return [4 /*yield*/, client.send(new client_rekognition_1.CreateCollectionCommand({ CollectionId: CollectionId }))];
                                case 4:
                                    _g.sent();
                                    return [4 /*yield*/, client.send(command)];
                                case 5:
                                    response = _g.sent();
                                    return [3 /*break*/, 7];
                                case 6:
                                    results.unindexed_reasons.push(err_1.message);
                                    return [2 /*return*/];
                                case 7: return [3 /*break*/, 8];
                                case 8:
                                    if ((response.UnindexedFaces || []).length > 0) {
                                        console.debug("Failed to index faces: " + JSON.stringify(response.UnindexedFaces));
                                        (_c = results.unindexed_reasons).push.apply(_c, __spreadArray([], __read((response.UnindexedFaces || []).map(function (f) { return (f.Reasons || []).join(', '); })), false));
                                    }
                                    try {
                                        for (_a = __values((response.FaceRecords || []).sort(function (a, b) {
                                            var _a, _b;
                                            if (!((_a = a.Face) === null || _a === void 0 ? void 0 : _a.Confidence))
                                                return 1;
                                            if (!((_b = b.Face) === null || _b === void 0 ? void 0 : _b.Confidence))
                                                return -1;
                                            if (a.Face.Confidence > b.Face.Confidence)
                                                return -1;
                                            return 1;
                                        })), _b = _a.next(); !_b.done; _b = _a.next()) {
                                            face = _b.value;
                                            if (!((_f = face.Face) === null || _f === void 0 ? void 0 : _f.FaceId))
                                                continue;
                                            if (ignoreFaces.includes(face.Face.FaceId))
                                                continue;
                                            console.debug("Indexed face for uid ".concat(ExternalImageId, ": "), face.Face, face.FaceDetail);
                                            results.indexed.push(face.Face.FaceId);
                                        }
                                    }
                                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                    finally {
                                        try {
                                            if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
                                        }
                                        finally { if (e_2) throw e_2.error; }
                                    }
                                    return [3 /*break*/, 10];
                                case 9:
                                    e_1 = _g.sent();
                                    results.unindexed_reasons.push(e_1.message);
                                    return [3 /*break*/, 10];
                                case 10: return [2 /*return*/];
                            }
                        });
                    }); };
                    if (!Name.endsWith('/')) return [3 /*break*/, 4];
                    s3 = (0, s3_1.getS3)();
                    return [4 /*yield*/, s3.send(new client_s3_1.ListObjectsV2Command({
                            Bucket: Bucket,
                            Prefix: Name
                        }))];
                case 1:
                    listObjectsResponse = _b.sent();
                    if (!(listObjectsResponse.Contents && listObjectsResponse.Contents.length > 0)) return [3 /*break*/, 3];
                    return [4 /*yield*/, Promise.all(listObjectsResponse.Contents.map(function (content) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                return [2 /*return*/, indexFaces(new client_rekognition_1.IndexFacesCommand({
                                        CollectionId: CollectionId,
                                        Image: { S3Object: { Bucket: Bucket, Name: content.Key } },
                                        ExternalImageId: ExternalImageId,
                                        MaxFaces: MaxFaces,
                                        QualityFilter: 'AUTO',
                                        DetectionAttributes: ['ALL']
                                    }))];
                            });
                        }); }))];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3: return [3 /*break*/, 6];
                case 4: 
                // If the path does not end with a slash, we can just extract the text from the file.
                return [4 /*yield*/, indexFaces(new client_rekognition_1.IndexFacesCommand({
                        CollectionId: CollectionId,
                        Image: { S3Object: { Bucket: Bucket, Name: Name } },
                        ExternalImageId: ExternalImageId,
                        MaxFaces: MaxFaces,
                        QualityFilter: 'AUTO',
                        DetectionAttributes: ['ALL']
                    }))];
                case 5:
                    // If the path does not end with a slash, we can just extract the text from the file.
                    _b.sent();
                    _b.label = 6;
                case 6: return [2 /*return*/, results];
            }
        });
    });
}
function searchImageInCollection(CollectionId, photoUrl) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var threshold, max_faces, client, regex, match, bucket, name, searchByImageCommand, response, e_3, faceMatches, results, _b, _c, f, imageId, _d, uid, secondPart, thirdPart, targetField;
        var e_4, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    threshold = 99;
                    max_faces = (CollectionId === null || CollectionId === void 0 ? void 0 : CollectionId.includes('brf')) ? 100 : 15;
                    client = new client_rekognition_1.RekognitionClient({});
                    if (!photoUrl) {
                        console.warn("No photo URL provided for a satellite collection search");
                        return [2 /*return*/, (0, neverthrow_1.err)("face_search_error")];
                    }
                    regex = /^https:\/\/([^.]+)\.s3\.amazonaws\.com\/(.+)$/;
                    match = photoUrl.match(regex);
                    if (!match) {
                        console.warn("Invalid photo URL for satellite collection search", photoUrl);
                        return [2 /*return*/, (0, neverthrow_1.err)("face_search_error")];
                    }
                    bucket = match[1];
                    name = (0, decode_1.safeDecodeURIComponent)(match[2]);
                    searchByImageCommand = new client_rekognition_1.SearchFacesByImageCommand({
                        CollectionId: CollectionId,
                        Image: { S3Object: { Bucket: bucket, Name: name } }, FaceMatchThreshold: threshold, MaxFaces: max_faces
                    });
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, client.send(searchByImageCommand)];
                case 2:
                    response = _f.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_3 = _f.sent();
                    console.warn("Error searching for face in satellite collection", e_3);
                    return [2 /*return*/, (0, neverthrow_1.err)("face_search_error")];
                case 4:
                    faceMatches = response.FaceMatches;
                    results = {};
                    try {
                        for (_b = __values((faceMatches || [])), _c = _b.next(); !_c.done; _c = _b.next()) {
                            f = _c.value;
                            if (!((_a = f.Face) === null || _a === void 0 ? void 0 : _a.ExternalImageId))
                                continue;
                            console.debug("Face Match: ", f.Face, "Similarity: ", f.Similarity);
                            imageId = f.Face.ExternalImageId;
                            // As of October 2024, this searchByImage logic should only be called for collections
                            // 'chicagorcp', 'cookcounty' on behalf of 'chicagocash'.
                            // Some older faceIDs in cookcounty and chicagorcp don't include the collection, or sometimes the targetField, in the ExternalImageID.
                            // We want to make sure the collection is included in our results regardless in this case.
                            // We really want to be careful modifying ExternalImageIDs, hence we limit it to chicagorcp and cookcounty
                            if (['chicagorcp', 'cookcounty'].includes(CollectionId)) {
                                _d = __read(f.Face.ExternalImageId.split(':'), 3), uid = _d[0], secondPart = _d[1], thirdPart = _d[2];
                                // If we don't already have all three pieces of uid:targetField:deployment, assemble it ourselves.
                                if (!secondPart || !thirdPart) {
                                    targetField = secondPart !== CollectionId ? secondPart : '';
                                    imageId = "".concat(uid, ":").concat(targetField, ":").concat(CollectionId);
                                }
                            }
                            results[imageId] = f.Face;
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                    return [2 /*return*/, (0, neverthrow_1.ok)(results)];
            }
        });
    });
}
exports.searchImageInCollection = searchImageInCollection;
function searchFaceInCollection(FaceId, CollectionId) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var threshold, max_faces, client, command, response, e_5, faceMatches, results, _b, _c, f;
        var e_6, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    threshold = 99;
                    max_faces = (CollectionId === null || CollectionId === void 0 ? void 0 : CollectionId.includes('brf')) ? 100 : 15;
                    client = new client_rekognition_1.RekognitionClient({});
                    command = new client_rekognition_1.SearchFacesCommand({
                        CollectionId: CollectionId,
                        FaceId: FaceId,
                        FaceMatchThreshold: threshold, MaxFaces: max_faces
                    });
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, client.send(command)];
                case 2:
                    response = _e.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_5 = _e.sent();
                    console.warn("Error searching for face", e_5);
                    return [2 /*return*/, (0, neverthrow_1.err)("face_search_error")];
                case 4:
                    faceMatches = response.FaceMatches;
                    results = {};
                    try {
                        for (_b = __values((faceMatches || [])), _c = _b.next(); !_c.done; _c = _b.next()) {
                            f = _c.value;
                            if (!((_a = f.Face) === null || _a === void 0 ? void 0 : _a.ExternalImageId))
                                continue;
                            console.debug("Face Match: ", f.Face, "Similarity: ", f.Similarity);
                            results[f.Face.ExternalImageId] = f.Face;
                        }
                    }
                    catch (e_6_1) { e_6 = { error: e_6_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_d = _b.return)) _d.call(_b);
                        }
                        finally { if (e_6) throw e_6.error; }
                    }
                    return [2 /*return*/, (0, neverthrow_1.ok)(results)];
            }
        });
    });
}
exports.searchFaceInCollection = searchFaceInCollection;
function hashFaceAtUrl(params) {
    return __awaiter(this, void 0, void 0, function () {
        var S3, collectionId, matches, token, photo, bucket, error, conversion, urlLower, hasExt, loc, buffer, _a, upload, indexResults, faces, unindexedReasons, e_7;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    S3 = new client_s3_1.S3Client({});
                    collectionId = JSON.parse(params.config['fraud'] || '{}').useSpecificFaceCollection || params.deploymentKey;
                    matches = params.url.match(/^https:\/\/(.*)\.s3\.amazonaws\.com\/(.*)$/);
                    return [4 /*yield*/, params.aidkitCrypto];
                case 1:
                    token = _b.sent();
                    if (!token) {
                        console.error("Cannot hash face at URL: missing hash or encryption key");
                        return [2 /*return*/, (0, neverthrow_1.err)("cannot_encrypt_without_key")];
                    }
                    photo = '';
                    bucket = matches && matches[1] || '';
                    error = '';
                    urlLower = params.url.toLowerCase();
                    if (!(bucket === 'aidkit-documents')) return [3 /*break*/, 2];
                    photo = (0, decode_1.safeDecodeURIComponent)(matches && matches[2] || '');
                    return [3 /*break*/, 8];
                case 2:
                    if (!(params.url.indexOf('workersfund-documents') !== -1 && params.url.toLowerCase().indexOf('.heic') === -1)) return [3 /*break*/, 3];
                    bucket = 'workersfund-documents';
                    photo = decodeURIComponent(params.url.split('https://workersfund-documents.s3.amazonaws.com/')[1]);
                    return [3 /*break*/, 8];
                case 3:
                    bucket = 'workersfund-documents';
                    if (!(params.url.indexOf('twilio') !== -1)) return [3 /*break*/, 7];
                    hasExt = (params.url.split('/').pop() || '').split('.').length >= 2;
                    loc = token.hashNoDecode(params.url) + "/" + params.url.split('/').pop() + (!hasExt ? '.jpg' : '');
                    _a = stream_1.streamToBuffer;
                    return [4 /*yield*/, (0, node_fetch_1.default)(params.url)];
                case 4: return [4 /*yield*/, _a.apply(void 0, [(_b.sent()).body])];
                case 5:
                    buffer = _b.sent();
                    bucket = 'aidkit-documents';
                    upload = new client_s3_1.PutObjectCommand({
                        Bucket: bucket,
                        Key: loc,
                        Body: buffer
                    });
                    return [4 /*yield*/, S3.send(upload)];
                case 6:
                    _b.sent();
                    photo = loc;
                    return [3 /*break*/, 8];
                case 7:
                    console.warn("Trying to detect face from unknown URL: ", params.url);
                    return [2 /*return*/, (0, neverthrow_1.err)("unknown_url_to_detect_face")];
                case 8:
                    _b.trys.push([8, 10, , 11]);
                    return [4 /*yield*/, addFacesToCollection({
                            Bucket: bucket,
                            Name: photo,
                            ExternalImageId: params.uid + ':' + params.key + ':' + params.deploymentKey,
                            CollectionId: collectionId,
                            config: params.config
                        })];
                case 9:
                    indexResults = _b.sent();
                    faces = indexResults['indexed'];
                    if (faces.length > 0) {
                        if (faces.length > 1) {
                            console.debug("Got multiple faces for one photo for uid: ", params.uid, ". Faces: ", faces);
                        }
                        return [2 /*return*/, (0, neverthrow_1.ok)({ indexedFaceId: faces[0], conversion: conversion })];
                    }
                    unindexedReasons = indexResults['unindexed_reasons'];
                    if (unindexedReasons.length > 0) {
                        return [2 /*return*/, (0, neverthrow_1.ok)({ unindexedReasons: unindexedReasons, conversion: conversion })];
                    }
                    return [2 /*return*/, (0, neverthrow_1.ok)({ unindexedReasons: ["No face detected"], conversion: conversion })];
                case 10:
                    e_7 = _b.sent();
                    console.warn("Error adding face to collection: ", e_7);
                    return [2 /*return*/, (0, neverthrow_1.err)("cannot_add_face_to_collection")];
                case 11: return [2 /*return*/];
            }
        });
    });
}
exports.hashFaceAtUrl = hashFaceAtUrl;
